/**
 * Check if a given object implements the CreateOfferGroupResponse interface.
 */
export function instanceOfCreateOfferGroupResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
export function CreateOfferGroupResponseFromJSON(json) {
    return CreateOfferGroupResponseFromJSONTyped(json, false);
}
export function CreateOfferGroupResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
export function CreateOfferGroupResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
